module.exports = __webpack_public_path__ + "static/media/ada_badge_white.ab9bb056.svg";